import styled from 'styled-components'

import dna from './assets/dna.jpg'

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  ${p => p.theme.mq.upMd} {
    margin-left: ${p => p.theme.indents.baseIndentMd};
    width: calc(50% - ${p => p.theme.indents.baseIndentMd});
  }

  ${p => p.theme.mq.upLg} {
    margin-left: ${p => p.theme.indents.baseBoxIndentLg};
    width: calc(33% - ${p => p.theme.indents.baseBoxIndentLg});
  }
`

export const Inner = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
`

export const Plug = styled.div`
  width: 100%;
  height: 100%;
  background: url(${dna}) top center / cover no-repeat;
`
